import { Navigate, useLocation } from 'react-router-dom';
import { getAccessToken, isTokenExpired } from '@utils/helpers';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const location = useLocation();
  const token = getAccessToken();

  if (!token || isTokenExpired(token)) {
    return <Navigate to="/login/phone" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};
